import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { BroadcastHandlersTabs } from "./BroadcastHandlers";

import {
  addStatusHandler,
  selectBroadcastStatusHandlers,
  setStatusHandlers,
} from "../store/slices/broadcastSlice";
import JsonCollapse from "../Builder/Components/JsonCollapse";

export default function StatusHandlers() {
  const dispatch = useDispatch();
  const statusHandlers = useSelector(selectBroadcastStatusHandlers);

  return (
    <div className="bg-purple-gradient p-3">
      <BroadcastHandlersTabs
        handlers={statusHandlers}
        setHandlers={(newHandlers) => {
          dispatch(setStatusHandlers(newHandlers));
        }}
      />
      <div
        className={`d-flex ${
          statusHandlers.length === 0
            ? "justify-content-center"
            : "justify-content-end"
        } `}
      >
        <button
          type="button"
          className="d-flex btn p-0 align-items-center gap-2 mb-3"
          onClick={() => {
            dispatch(addStatusHandler());
          }}
        >
          <span
            className={`fw-bold ${statusHandlers.length === 0 ? "fs-5" : ""} `}
          >
            <FontAwesomeIcon
              icon={faPlus}
              className="bg-colored text-white p-1  me-2 rounded-pill "
            />
            ADD STATUS HANDLER
          </span>
        </button>
      </div>
      <JsonCollapse json={statusHandlers} />
    </div>
  );
}
